import React from 'react';
import { Link } from 'react-router-dom';
import MainHeading from '../Common/MainHeading';
import { useLocale } from '../../localization/LocaleContext';
import './OurFeatures.css';

const featureItems = [
    {
        routeKey: 'aiEstimator',
        navKey: 'aiEstimator',
        descKey: 'aiEstimator',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 1 C8.5 4.5 11.5 7.5 16 9 C11.5 10.5 8.5 13.5 8 17 C7.5 13.5 4.5 10.5 0 9 C4.5 7.5 7.5 4.5 8 1 Z"/>
                <path d="M18 13 C18.25 14.5 19.75 16.5 22 17 C19.75 17.5 18.25 19.5 18 21 C17.75 19.5 16.25 17.5 14 17 C16.25 16.5 17.75 14.5 18 13 Z"/>
            </svg>
        ),
    },
    {
        routeKey: 'quotes',
        navKey: 'quotes',
        descKey: 'quotes',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="9" y1="13" x2="15" y2="13"/>
                <line x1="9" y1="17" x2="15" y2="17"/>
            </svg>
        ),
    },
    {
        routeKey: 'invoicing',
        navKey: 'invoicing',
        descKey: 'invoicing',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        ),
    },
    {
        routeKey: 'timeTracking',
        navKey: 'timeTracking',
        descKey: 'timeTracking',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
            </svg>
        ),
    },
    {
        routeKey: 'payments',
        navKey: 'payments',
        descKey: 'payments',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
        ),
    },
    {
        routeKey: 'paymentReminders',
        navKey: 'paymentReminders',
        descKey: 'paymentReminders',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
        ),
    },
    {
        routeKey: 'reports',
        navKey: 'reports',
        descKey: 'reports',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="20" x2="18" y2="10"/>
                <line x1="12" y1="20" x2="12" y2="4"/>
                <line x1="6" y1="20" x2="6" y2="14"/>
            </svg>
        ),
    },
    {
        routeKey: 'clients',
        navKey: 'clients',
        descKey: 'clients',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
        ),
    },
];

export default function OurFeatures(){
    const { t, toLocalizedPath } = useLocale();

    return(
        <section className="features sp-90">
            <MainHeading headingName={t('homeFeatureGrid.heading')} />
            <p className="paragraph p-adjustment text-center m-center homeFeatureGrid-subheading">
                {t('homeFeatureGrid.subheading')}
            </p>
            <div className="container spt-60">
                <div className="homeFeatureGrid">
                    {featureItems.map((item) => (
                        <Link
                            to={toLocalizedPath(item.routeKey)}
                            className="homeFeatureGrid-card"
                            key={item.routeKey}
                        >
                            <div className="homeFeatureGrid-icon">{item.icon}</div>
                            <h3 className="h-5 bold-500 homeFeatureGrid-title">{t(`nav.${item.navKey}`)}</h3>
                            <p className="paragraph p-adjustment mb-0">{t(`homeFeatureGrid.${item.descKey}Description`)}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    )
}